<template>
  <div class="layout-container">
    <MemberAlertsModal v-model="memberAlertsModalShowing" :member-id="$route.params.userId" />
    <sidebar>
      <div>
        <v-btn
          class="member-list-button mb-16 w-100"
          color="#4D5AFF"
          large
          :to="{ name: 'member-list' }"
        ><v-icon left class="pr-5">mdi-apps</v-icon> {{ $t('Your citizens') }}</v-btn>

        <div class="member-name mb-10" v-html="nameWithBreaks"></div>

        <div class="member-info-box">
          <div v-if="notificationsPermissions" class="member-info-item">
            <v-btn
              color="white"
              outlined
              style="width: 100%;white-space: normal;"
              @click="memberAlertsModalShowing = true"
            >{{ $t('Toggle task notifications') }}</v-btn>
          </div>
          <div class="member-info-item">
            <router-link
              class="text-decoration-none"
              :to="{ name: 'member-edit' }"
            >
              <v-btn
                text
                color="white"
              >
                {{ $t('Edit information') }}
              </v-btn>
            </router-link>
          </div>
        </div>
      </div>
    </sidebar>

    <div class="content">
      <transition name="slide" mode="out-in" appear>
        <router-view>

        </router-view>
      </transition>
    </div>
  </div>
</template>

<script>

import Sidebar from '@/globals/components/Sidebar.vue';
import MemberAlertsModal from '@/modules/alerts/MemberAlertsModal.vue';

export default {
  components: {
    Sidebar,
    MemberAlertsModal,
  },
  data() {
    return {
      showSidebar: true,
      memberAlertsModalShowing: false,
    };
  },
  created() {
    if (!this.$Member.find(this.$route.params.userId)) {
      this.$Member.api().fetchByUserId(this.$route.params.userId);
    }
  },
  computed: {
    notificationsPermissions() {
      return this.$p.hasAll('notifications');
    },
    member() {
      return this.$Member.find(this.$route.params.userId);
    },
    nameWithBreaks() {
      return this.member ? this.member.fullName.split(' ').join('<br/>') : '';
    },
  },
};

</script>

<style scoped lang="scss">
  .layout-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
  }

  .sidebar {
    .member-list-button {
      color: #fff;
    }

    .member-name {
      font-size: 32px;
      font-weight: 100;
      word-break: break-all;
    }

    .member-info-box {
      display: flex;
      flex-direction: column;
    }

    .member-info-item {
      margin-bottom: 20px;
    }

    .member-info-label {
      font-weight: bold;
      color: rgba(255, 255, 255, 0.6);
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      margin-bottom: 6px;
    }

    .member-info-value {

    }
  }

  .content {
    flex: 1;
    display: flex;
    max-height: 100vh;
    overflow: auto;
  }
</style>
